/**
 * The blocking `me` loader may only be shown while there is no user in the store yet.
 * Once a user is loaded, refreshes have to stay in the background: swapping the root
 * navigator for a loader unmounts it, which resets navigation state (web lands on
 * /about) and bounces the onboarding name step back to the onboarding gate.
 */
export const shouldSetMeLoading = (hasUser: boolean) => !hasUser

export const shouldBlockUiForMeLoad = ({
  isLoggedIn,
  isMeLoading,
  hasUser
}: {
  isLoggedIn: boolean
  isMeLoading: boolean
  hasUser: boolean
}) => isLoggedIn && isMeLoading && !hasUser
